export default __webpack_public_path__ + "static/media/frames_11x15.7a486816.jpg";